<template>
  <grid-select
    v-model="selectedValue" 
    :label="label" 
    :defaultLabel="defaultLabel"
    :valueField="valueField"
    :labelField="labelField"
    :placeholder="placeholder"
    :size="size" 
    :searchItems="searchItems"
    :gridItems="gridItems"
    :getDataList="isUser ? listGbpxCourseCategoryU : listGbpxCourseCategory"
    @change="handleChange"
  ></grid-select>
</template>

<script>
import { listGbpxCourseCategory, listGbpxCourseCategoryU } from "@/api/gbpx/gbpx_course_category";

export default {
  name: 'course-category-select',
  props: {
    value: {
      type: [String, Number],
      default: () => { return null }
    },
    label: {
      type: String,
      default: () => { return null }
    },
    defaultLabel: {
      type: String,
      default: () => { return null }
    },
    valueField: {
      type: String,
      default: () => { return "id" }
    },
    labelField: {
      type: String,
      default: () => { return "name" }
    },
    placeholder: {
      type: String,
      default: () => { return '请选择' }
    },
    size: {
      type: String,
      default: () => { return 'medium' }
    },
    isUser: {
      type: Boolean,
      default: () => { return false }
    }
  },
  data() {
    return {
      listGbpxCourseCategory: listGbpxCourseCategory,
      listGbpxCourseCategoryU: listGbpxCourseCategoryU,
      selectedValue: this.value,
      searchItems: [{field: 'name', title: '名称'}],
      gridItems: [{field: 'name', title: '名称'}, {field: 'remark', title: '备注'}]
    }
  },
  created() {
  },
  methods: {
    handleChange(e1, e2) {
      this.$emit('input', e1)
      this.$emit('change', e1, e2)
    }
  },
  watch: {
    value(val) {
      this.selectedValue = val
    }
  }
}
</script>
